import axios from 'axios'

export const validateLineNumber = async (body: Record<string, string>) => {
  const fetchUrl = '/portaQualification/portabilidad/linea'
  const request = { linea: body.line, tipoDoc: body.documentType, nroDoc: body.documentNumber }
  const { data } = await axios.post(fetchUrl, request)
  return data
}

export const reSendPinCustomer = async (body: Record<string, string>) => {
  const fetchUrl = '/portaQualification/portabilidad/pin'
  const request = { linea: body.line, tipoDoc: body.documentType, nroDoc: body.documentNumber }
  const { data } = await axios.post(fetchUrl, request)
  return data
}
